import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import URL from '../../../constants/urls'
import { deleteCard, getCardLists, makeDefaultCardData } from '../../../redux/actions/PaymentAction'
import ListItems from '../ListItems'
import MiniHeader from '../MiniHeader'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY } from '../../../constants/globalConstants'
import Loader from '../../../global/Loader'
import ConfirmationTerms from '../../../global/ConfirmationTerms'
import { addEventLog } from '../../../redux/actions/EventsLog'
import CONSTANTS from '../../../redux/constants'
import { errorMessage } from '../../../constants/errorMessage'

function PaymentList(props) {
    const {notify, dispatch, loader} = props
    const navigate = useNavigate()
    const {partner} = useParams()
    const [cardData, setCardData] = useState()
    const [isConfimationModalOpen, setIsConfimationModalOpen] = useState(false)
    const [deleteId, setDeleteId] = useState(null)
    const [makedefaultModal, setMakedefaultModal] = useState(false)
    const [defaultItem, setDefaultItem] = useState(EMPTY_ARRAY)
    const [deleteConfirmMessage, setDeleteConfirmMessage] = useState('Are you sure you want to delete?')
    
    useEffect(() => {
        paymentListData()
    },[EMPTY_ARRAY])

    

    const handleAdd = () => {
        navigate(`/${partner}/${URL?.ADD_CARD}`)
    }

    const handleDeleteConfirmation = (id) => {
        setIsConfimationModalOpen(!isConfimationModalOpen)
        const cardToDelete = cardData?.filter((card) => card?.id == id)
        if(cardToDelete?.[0]?.is_default && cardToDelete?.[0]?.is_default == 1){
            setDeleteConfirmMessage('You’re about to delete your default card, which may affect ongoing payments. Please add and set a new default card. Do you wish to continue?')
        }else{
            setDeleteConfirmMessage('Are you sure you want to delete?')
        }
        setDeleteId(id)
    }

    const handleDelete = () => {
        // const facilityLocData = JSON.parse(localStorage.getItem('faclityData'))
        // const localFacilityID = facilityLocData?.facility?.id ? facilityLocData.facility.id : null
        const selectedCard = cardData?.filter((card) => card?.id == deleteId)
        const payload = {
            id: deleteId,
            // facility_id: localFacilityID
            card_last_four: selectedCard?.[0]?.card_last_four,
            expiry: selectedCard?.[0]?.expiry
        }
        setIsConfimationModalOpen(false)
        dispatch(deleteCard(payload)).then((res) => {
            if(res?.data){
                notify('success', 'Card Deleted')
                paymentListData()
            }
        }).catch((err) => {
            let errObject = { 
                payload: payload,
                error: err,
                errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong  
            }
            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} deleteCard-PaymentList.js-58`))
            notify('error', err)
        })
    }
    
    
    const handleDefaultCard = (item) => {
        setDefaultItem(item)
        setMakedefaultModal(true)
    }
    const handleDefault = () => {
        setMakedefaultModal(false)
        const payload = {
            'id': defaultItem?.id,
            'user_id': defaultItem?.user_id,
            'is_default': 1,
            'expiry': defaultItem?.expiry ? defaultItem?.expiry : '',
            'card_last_four': defaultItem?.card_last_four ? defaultItem?.card_last_four : ''
        }
        dispatch(makeDefaultCardData(payload)).then((res) => {
            if (res?.status === 201 && res?.data !== null) {
                notify('success', 'Card Updated')
                paymentListData()
            } else {
                notify('error', res?.errors?.message ? res?.errors?.message : 'Something went wrong, Please try again!')
            }
        }).catch((errors) => {
            notify('error', errors?.message ? errors?.message : 'Something went wrong, Please try again!')
        })
    }
    const paymentListData = () => {
        dispatch(getCardLists()).then((res) => {
            setCardData(res?.data?.payments)
        }).catch((err) => {
            notify('error', err)
        })
    }
    return (
        <div className='main'>
        <MiniHeader title={'PAYMENTS'} isDisplayBack isAddIcon handleAdd={handleAdd}/>
            <div className='mt-2'>
                <span className='text-primary m-3 mt-3 small fw-semibold'>Saved Payment Methods</span>
                {(loader) ? <div className='d-flex align-items-center justify-content-center vh-70'><Loader /></div> : 
                <ListItems data={cardData} handleDelete={handleDeleteConfirmation} handleDefaultCard={handleDefaultCard}/>}
            </div>
            <ConfirmationTerms
                isConfimationModalOpen={isConfimationModalOpen}
                setIsConfimationModalOpen={setIsConfimationModalOpen}
                Message={deleteConfirmMessage}
                cancelButton={true}
                SubmitButton={true}
                cancelButtonLabel='No'
                SubmitButtonLable='Yes'
                SubmitButtonColor='text-danger'
                handleLogout={handleDelete}
            />
            <ConfirmationTerms
                isConfimationModalOpen={makedefaultModal}
                setIsConfimationModalOpen={setMakedefaultModal}
                Message='Do you wish to set this as your default Payment Method?'
                cancelButton={true}
                SubmitButton={true}
                cancelButtonLabel='Cancel'
                SubmitButtonLable='Confirm'
                SubmitButtonColor='text-danger'
                handleLogout={handleDefault}
            />
        </div>
    )
}
PaymentList.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    notify: PropTypes.func,
}

PaymentList.defaulProps = {
    dispatch: noop,
    loader: true,
    notify: noop,
}

function mapStateToProps({ PaymentReducer }) {
    return {
        loader: PaymentReducer?.loader
    }
}
export default connect(mapStateToProps)(PaymentList)
